import React, { useMemo, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { Bounds, Grid, OrbitControls, GizmoHelper, GizmoViewport } from "@react-three/drei";
import ProfileExtrudeMesh from "../geometry/ProfileExtrudeMesh";
import FramedPanelPreview3D from "./FramedPanelPreview3D";

export default function BoardPreview3D({
  profile,
  parameters,
  selected = false,
}) {
  const safeParams = useMemo(() => parameters || {}, [parameters]);
  const controlsRef = useRef(null);

  return (
    <div className="w-full h-full min-h-[500px] border rounded overflow-hidden">
      <Canvas
        camera={{ position: [1200, 900, 1200], fov: 28, near: 1, far: 20000 }}
        shadows
      >
        <color attach="background" args={["#f5f5f5"]} />
        <ambientLight intensity={1.4} />
        <directionalLight position={[3000, 4000, 2000]} intensity={1.2} castShadow />

        <Grid
          args={[10000, 10000]}
          cellSize={100}
          sectionSize={500}
          fadeDistance={15000}
          fadeStrength={1}
          infiniteGrid
        />

        <axesHelper args={[1000]} />

        <Bounds fit clip observe margin={1.2}>
          {profile?.type === "framed_panel" ? (
  <FramedPanelPreview3D
    profile={profile}
    parameters={safeParams}
    selected={selected}
  />
) : (
  <ProfileExtrudeMesh
    profile={profile}
    parameters={safeParams}
    thicknessExpr="thickness"
    color={selected ? "#60a5fa" : "#d1d5db"}
  />
)}
        </Bounds>

        <OrbitControls
  ref={controlsRef}
  makeDefault
  enableDamping={false}
  dampingFactor={0}
  rotateSpeed={0.65}
  zoomSpeed={0.8}
  panSpeed={0.8}
/>

        <GizmoHelper alignment="bottom-right" margin={[80, 80]}>
          <GizmoViewport />
        </GizmoHelper>
      </Canvas>
    </div>
  );
}